import { Injectable, OnDestroy } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SigningOnPdfService implements OnDestroy {
  singpassData = new BehaviorSubject<any>(null);

  ngOnDestroy(): void {}
}
